// ----------------------------------------------------------------------------
// Template: Gift Card
// ----------------------------------------------------------------------------
// A file that contains scripts highly couple code to the Gift Card template.
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';
import 'sections/header/header';
import 'sections/footer/footer';

import './_gift-card.scss';


// -------------------------------------
// Variables
// -------------------------------------

const config = {
    qrCode: '#QrCode',
    printButton: '#PrintGiftCard',
    giftCardCode: '.giftcard__code',
};


// -------------------------------------
// Helper Functions
// -------------------------------------
function selectText(evt) {
    const text = document.getElementById(evt.data.element);
    let range = '';

    if (document.body.createTextRange) {
        range = document.body.createTextRange();
        range.moveToElementText(text);
        range.select();
    } else if (window.getSelection) {
        const selection = window.getSelection();
        range = document.createRange();
        range.selectNodeContents(text);
        selection.removeAllRanges();
        selection.addRange(range);
    }
}

// new QRCode($qrCode[0], {
//   text: $qrCode.attr('data-identifier'),
//   width: 120,
//   height: 120,
// });


// -------------------------------------
// Hooks
// -------------------------------------

$(document).ready(function() {
    $(config.printButton).on('click', () => {
        window.print();
    });

    // Auto-select gift card code on click, based on ID passed to the function
    $(config.giftCardCode).on('click', {element: 'GiftCardDigits'}, selectText);
})


